// Water running (calls round, step 2): for a leak or a burst, two questions decide how soon. "Is water
// running now?" and "Is it shut off?". Running and not shut off: an emergency, booked as after hours or
// emergency, now. Running but shut off at the valve: today. Not running: as booked. Kept out of the form
// so it's tested without a browser.

/** The reasons that ask it: a job type or what's wrong naming a leak, a burst or a flood. */
const WET = /\b(leak|leaks|leaking|burst|bursts|flood|flooding|flooded|water running)\b/i;

/** The question shows for this job type and what's wrong. */
export const asksWater = (...words: (string | null | undefined)[]) => words.some((w) => !!w && WET.test(w));

export interface WaterAnswer {
  /** Is water running now? null until asked. */
  running: boolean | null;
  /** Is it shut off? Asked once it's running. */
  shutOff: boolean | null;
}

export const NO_WATER_ANSWER: WaterAnswer = { running: null, shutOff: null };

export type WaterUrgency = 'emergency' | 'today' | null;

/** How soon, from the answers: null leaves the booking as it is. */
export function waterUrgency(w: WaterAnswer): WaterUrgency {
  if (w.running !== true) return null;
  if (w.shutOff === false) return 'emergency';
  if (w.shutOff === true) return 'today';
  return null;
}

/** The emergency's reason, said on the booking (after hours or emergency asks why it can't wait). */
export const WATER_EMERGENCY_REASON = 'Water is running and isn’t shut off';

/** What the form says under the questions. */
export function waterWords(u: WaterUrgency): string | null {
  if (u === 'emergency')
    return 'Emergency: water is running and isn’t shut off. Booked as after hours or emergency, today.';
  if (u === 'today') return 'Today: the water’s shut off, so it takes today’s next window.';
  return null;
}
